export default "__VITE_PUBLIC_ASSET__8cc7dbc2__"